module.exports = __webpack_public_path__ + "img/insta.21a7482b.svg";